<template>
  <div class="face">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="banner"><img src="@/assets/images/personalInfo/banner.png"></div>
        <div class="conList">
          <ul>
            <li><img src="@/assets/images/personalInfo/toolbar_zgsf.png"><span>尊贵身份，优先体验</span></li>
            <li><img src="@/assets/images/personalInfo/toolbar_sfxx.png"><span>身份信息冒用，提前防范</span></li>
            <li><img src="@/assets/images/personalInfo/toolbar_zhaq.png"><span>账户安全升级，放心理财</span></li>
          </ul>
          <p>为了您的账户安全，请通过以下方式面部识别，证明是本人操作。 识别过程中请勿佩戴眼镜；</p>
          <p class="color">下载官方APP，更快捷通过面部识别</p>
        </div>
        <div class="btnItem">
          <span class="submit" @click="downLoad">立即下载</span>
          <Chat />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/faceValidate.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'
export default {
  name: 'FaceValidate',
  components: { Header, Chat },
  data() {
    const u = navigator.userAgent
    return {
      title: '脸部识别',
      rightContent: 'isNo',
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    downLoad() {
      const urls = {
        'android': 'https://dl.cfxz123.com/source/material/CFD_APP.apk',
        'ios': 'https://itunes.apple.com/cn/app/id1153506842?mt=8'
      }
      try {
        if (this.isIOS) {
          window.location.href = urls.ios
        } else {
          window.location.href = urls.android
        }
      } catch (e) {
      }
    }
  }
}
</script>
